"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DisplayHandler_1 = __importDefault(require("./___subComponents/DisplayHandler"));
var InfiniteLoader_1 = __importDefault(require("./___subComponents/InfiniteLoader"));
var ScrollRenderer_1 = __importDefault(require("./___subComponents/ScrollRenderer"));
var ScrollToTopButton_1 = __importDefault(require("./___subComponents/ScrollToTopButton"));
var uiFunctions_1 = require("./___subComponents/uiFunctions");
var withList_1 = __importDefault(require("./___subComponents/withList"));
var isType_1 = require("./___utils/isType");
var flatListProps_1 = require("./flatListProps");
function FlatList(props) {
    var list = props.list, _a = props.renderWhenEmpty, renderWhenEmpty = _a === void 0 ? null : _a, wrapperHtmlTag = props.wrapperHtmlTag, _b = props.renderItem, renderItem = _b === void 0 ? null : _b, renderOnScroll = props.renderOnScroll, // render/list related props
    _c = props.group, // render/list related props
    group = _c === void 0 ? {} : _c, groupSeparator = props.groupSeparator, // group props
    _d = props.display, // group props
    display = _d === void 0 ? {} : _d, displayRow = props.displayRow, rowGap = props.rowGap, displayGrid = props.displayGrid, gridGap = props.gridGap, minColumnWidth = props.minColumnWidth, // display props,
    hasMoreItems = props.hasMoreItems, loadMoreItems = props.loadMoreItems, paginationLoadingIndicator = props.paginationLoadingIndicator, paginationLoadingIndicatorPosition = props.paginationLoadingIndicatorPosition, scrollToTop = props.scrollToTop, _e = props.scrollToTopButton, scrollToTopButton = _e === void 0 ? null : _e, scrollToTopPadding = props.scrollToTopPadding, scrollToTopOffset = props.scrollToTopOffset, scrollToTopPosition = props.scrollToTopPosition, _f = props.pagination, pagination = _f === void 0 ? {} : _f, // pagination props
    __forwarededRef = props.__forwarededRef, otherProps = __rest(props, ["list", "renderWhenEmpty", "wrapperHtmlTag", "renderItem", "renderOnScroll", "group", "groupSeparator", "display", "displayRow", "rowGap", "displayGrid", "gridGap", "minColumnWidth", "hasMoreItems", "loadMoreItems", "paginationLoadingIndicator", "paginationLoadingIndicatorPosition", "scrollToTop", "scrollToTopButton", "scrollToTopPadding", "scrollToTopOffset", "scrollToTopPosition", "pagination", "__forwarededRef"]);
    var tagProps = Object.keys(otherProps)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .filter(function (k) { return (flatListProps_1.defaultProps[k] === undefined); })
        .reduce(function (p, k) {
        var _a;
        return (__assign(__assign({}, p), (_a = {}, _a[k] = otherProps[k], _a)));
    }, {});
    var renderThisItem = (0, uiFunctions_1.handleRenderItem)(renderItem, (0, uiFunctions_1.handleRenderGroupSeparator)(group.separator || groupSeparator));
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        list.length > 0
            ? (renderOnScroll && !(loadMoreItems || pagination.loadMore))
                ? (react_1.default.createElement(ScrollRenderer_1.default, { list: list, renderItem: renderItem, groupSeparator: group.separator || groupSeparator }))
                : list.map(function (item, index) { var _a; return renderThisItem(item, (_a = item.id) !== null && _a !== void 0 ? _a : index); })
            : (0, uiFunctions_1.renderBlank)(renderWhenEmpty),
        (displayRow || displayGrid || display.grid || display.row)
            && react_1.default.createElement(DisplayHandler_1.default, __assign({}, { display: display, displayRow: displayRow, rowGap: rowGap, displayGrid: displayGrid, gridGap: gridGap, minColumnWidth: minColumnWidth })),
        ((loadMoreItems || pagination.loadMore) && !renderOnScroll)
            && (react_1.default.createElement(InfiniteLoader_1.default, { itemsCount: list.length, hasMore: hasMoreItems || pagination.hasMore, loadMore: loadMoreItems || pagination.loadMore, loadingIndicator: paginationLoadingIndicator || pagination.loadingIndicator, loadingIndicatorPosition: paginationLoadingIndicatorPosition || pagination.loadingIndicatorPosition }))));
    var showScrollToTopButton = (scrollToTop === true || scrollToTop.button || scrollToTopButton);
    var WrapperElement = '';
    if (((0, isType_1.isString)(wrapperHtmlTag) && wrapperHtmlTag) || showScrollToTopButton) {
        WrapperElement = wrapperHtmlTag || 'div';
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        WrapperElement
            // @ts-ignore
            ? react_1.default.createElement(WrapperElement, __assign({ ref: __forwarededRef }, tagProps), content)
            : content,
        showScrollToTopButton
            && (react_1.default.createElement(ScrollToTopButton_1.default, { button: scrollToTopButton, padding: scrollToTopPadding, offset: scrollToTopOffset, position: scrollToTopPosition, scrollingContainer: __forwarededRef }))));
}
FlatList.propTypes = flatListProps_1.propTypes;
FlatList.defaultProps = flatListProps_1.defaultProps;
exports.default = (0, react_1.memo)((0, withList_1.default)((0, react_1.forwardRef)(function (props, ref) {
    ref = ref || (0, react_1.createRef)();
    return (react_1.default.createElement(FlatList, __assign({}, props, { __forwarededRef: ref })));
})));
//# sourceMappingURL=flatlist-react.js.map